module.exports = __webpack_public_path__ + "img/avatar.9591b355.jpg";